import React, { Suspense } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/themify-icons.css";
import "./assets/css/font-awesome.css";
import "./assets/css/animate.min.css";
import "./assets/css/animsition.css";
import "./assets/css/flexslider.css";
import "./assets/css/style.css";
import "./assets/css/header.css";
import "react-toastify/dist/ReactToastify.css";
import Home from "./components/Home/Home";
import AppRoute from "./routes/route";
import { authProtectedRoutes, publicRoutes } from "./routes/index";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { useMemo } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";

function App() {
  const getProtectedRoutes = useMemo(() => {
    return authProtectedRoutes.map((route) => (
      <AppRoute
        path={route.path}
        component={route.component}
        isAuthProtected={true}
        pageId={route.pageId}
        exact={route.exact}
      />
    ));
  }, [authProtectedRoutes]);

  const getPublicRoutes = useMemo(() => {
    return publicRoutes.map((route) => (
      <Route
        path={route.path}
        component={route.component}
        isAuthProtected={false}
        pageId={route.pageId}
        exact={route.exact}
        render={(props) => (
          <>
            <route.component {...props} />
          </>
        )}
      />
    ));
  }, [publicRoutes]);

  return (
    <Router>
      <Suspense fallback={() => <div></div>}>
        <Switch>{[...getPublicRoutes, ...getProtectedRoutes]}</Switch>
      </Suspense>
    </Router>
  );
}

export default App;
